import TexsOutGridController from './texs-out-grid.controller';
import Template from './texs-out-grid.html';

export default {
	bindings: {
		loading: '=',
		table: '=',
		pipe: '@',
		isDnd: '<'
	},
	controller: TexsOutGridController,
	template: Template
};
